import { useFormContext } from 'react-hook-form'

const GroupByColumns = [
    {
        Header: 'Source.Column',
        accessor: `sourceColumn`,
        Cell: ({
            cell,
            value: initialValue,
            row: { index },
            column: { id, accessor },
        }) => {
            const { control, register } = useFormContext()
            const formattedValue =
                initialValue &&
                `${initialValue.split('.')[0]}.${initialValue.split('.')[1]}`
            return (
                <>
                    {initialValue && (
                        <span>
                            {initialValue.split('.')[0]}.
                            <b>{initialValue.split('.')[1]}</b>
                        </span>
                    )}
                    {/* register an invisible input to allow for react hook form value tracking on a viewOnly field */}
                    <input
                        name={`groupBy[${index}].sourceColumn`}
                        ref={register()}
                        className={`collapsedField`}
                        defaultValue={formattedValue}
                    />
                </>
            )
        },
    },
    {
        Header: 'Column Type',
        accessor: 'dataType',
        Cell: ({
            cell,
            value: initialValue,
            row: { index },
            column: { id, accessor },
        }) => {
            const { control, register } = useFormContext()
            return (
                <>
                    {initialValue}
                    {/* register an invisible input to allow for react hook form value tracking on a viewOnly field */}
                    <input
                        name={`groupBy[${index}].dataType`}
                        ref={register()}
                        className={`collapsedField`}
                        defaultValue={initialValue}
                    />
                </>
            )
        },
    },
]

export default GroupByColumns
